import React from 'react';
import './ContentLayout.css';
import AboutSection from '../AboutSection/AboutSection';
import StickyContactForm from '../StickyContactForm/StickyContactForm';
import PriceSection from '../PriceSection/PriceSection';
import WalkThroughSection from '../WalkThroughSection/WalkThroughSection';
import FloorPlanSection from '../FloorPlanSection/FloorPlanSection';
import SpecificationsSection from '../SpecificationsSection/SpecificationsSection';
import MasterPlanSection from '../MasterPlanSection/MasterPlanSection';
import LocationSection from '../LocationSection/LocationSection';

const ContentLayout = ({ onRequestBrochure }) => {
  return (
    <div className="content-layout">
      <div className="container">
        <div className="layout-grid">
          {/* Main Content */}
          <div className="main-content">
            <AboutSection onRequestBrochure={onRequestBrochure} />
            <PriceSection />
            <WalkThroughSection />
            <FloorPlanSection />
            <SpecificationsSection />
            <MasterPlanSection />
            <LocationSection />
          </div>
          <aside className="sidebar">
            <StickyContactForm />
          </aside>
        </div>
      </div>
    </div>
  );
};

export default ContentLayout;